<!-- 聊天消息 -->
<template>
  <avue-drawer
    :width="700"
    :visible.sync="drawerShow"
    :value="drawerShow"
    :show-close="true"
    :wrapperClosable="false"
    :before-close="drawerCloseHandler"
  >
    <template slot="title">
      <span>{{ $lang("会话历史记录") }}</span>
    </template>
    <div class="drawer-container">
      <template v-if="drawerListMap && drawerListMap.length > 0">
        <div v-for="item in drawerListMap" :key="item.id" class="drawer-article" :class="getAuthorType(item) === 'CUSTOMER' ? 'visitor' : 'seats'">
          <img
            class="drawer-avater"
            :src="getAvaterUrl(item)"
            alt=""
          />
          <div class="drawer-msg">
            <div class="drawer-title">
              <span>
                <!-- <span class="avatar-name">{{ getAuthor(item) }}</span> -->
                <span>{{ getName(item) }}</span>
              </span>
              <span>{{ item.createTime }}</span>
            </div>
            <div v-if="item.status === MESSAGE_STATE_TYPE.RECALLED">
              <div class="withdraw">【该消息已撤回】</div>
            </div>
            <div class="drawer-text" v-if="item.msgType === MESSAGE_TYPE.TEXT">
              <span class="text" v-html="DOMPurify(item.msg)"></span>
            </div>
            <el-image
              v-else-if="item.msgType === MESSAGE_TYPE.IMG"
              fit="cover"
              class="drawer-image"
              :src="item.msg"
              @click="showImage(item.msg)"
            />
            <FileCard
              v-else-if="item.msgType === MESSAGE_TYPE.FILE"
              :data="item"
            />
            <div v-if="item.author === 'CUSTOMER'&&item.suggestReply">
              {{item.suggestReply.content.content}}
            </div>
            <!-- 机器人消息 -->
            <div v-else-if="item.msgType === MESSAGE_TYPE.ROBOT" class="robot">
              <template v-for="(robotList, robotIndex) in item.msg.contents">
                <span v-if="robotList.textSend" :key="robotIndex + 'textSend'"> {{ robotList.content }}</span>
                <span v-else-if="robotList.html" :key="robotIndex + 'html'" v-html="robotList.content" @click="clickHtml($event)"></span>
                <component :is="getComponent(robotList)" v-else-if="getComponent(robotList)" :option="robotList" class="is-component" :key="robotIndex + 'card'" />
                <span v-else :key="robotIndex">
                  {{ robotList.content }}
                </span>
              </template>
              <span v-for="(testList, testIndex) in item.msg.testContents" :key="testIndex + 'line'">
                <template v-if="testList.line">
                  <br />
                </template>
                {{ testList.content }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template>
        <div class="noData">暂无数据</div>
      </template>
    </div>
    <BaseImageView
      ref="img-view"
      v-if="show"
      :initial-index="initSrcIndex"
      :onClose="() => (show = false)"
      :url-list="previewSrcList"
    >
    </BaseImageView>
  </avue-drawer>
</template>

<script>
/**
 * @description 聊天消息类型
 */
const MESSAGE_TYPE = {
  TEXT: 'TEXT', // 文本
  IMG: 'IMG', // 图片
  FILE: 'FILE', // 文件
  VIDEO: 'VIDEO', // 视频
  LINK: 'LINK', // 链接
  ROBOT: 'ROBOT', // 机器人
  AUDIO: 'AUDIO' // 音频
};
/**
 * @description 聊天消息来源
 */
const MESSAGE_SOURCE_TYPE = {
  COMMON: 'COMMON', // 普通消息
  SYSTEM: 'SYSTEM', // 系统消息
  ROBOT: 'ROBOT' // 机器人消息
};
/**
 * @description 聊天消息发送者
 */
const MESSAGE_AUTHOR_TYPE = {
  AGENT: 'AGENT', // 坐席
  VISITOR: 'CUSTOMER' // 访客
};

/**
 * @description 聊天消息状态
 */
const MESSAGE_STATE_TYPE = {
  SEND: 'SEND', // 发送中
  SUCCESS: 'RECEIVED', // 发送成功
  FAILED: 'FAILED', // 发送失败
  READ: 'READ', // 接收方已读
  RECALLED: 'RECALLED' // 消息撤回
}

import FileCard from './chat-list/FileCard.vue'

// import systemAvatar from '@/assets/images/ft-img/service_avatar.png'
import visitor from '@/assets/images/ft-img/service_visitor.jpg'
import seats from '@/assets/images/ft-img/service_seats.png'
import { getImgSrcObj, replaceEmoji } from '@/common/utils/tool'
import { ImApi } from '../pool';
import ButtonComp from '@/views/flying-rabbit/_components/card-msg/ButtonComp.vue'
import OptionComp from '@/views/flying-rabbit/_components/card-msg/OptionComp.vue'
import GuessComp from '@/views/flying-rabbit/_components/card-msg/GuessComp.vue'
import CardList from '@/views/flying-rabbit/_components/card-msg/CardList.vue'
import DOMPurify from 'dompurify'

export default {
  components: {
    FileCard,
    ButtonComp, OptionComp, GuessComp, CardList
  },
  props: {
    drawerShow: {
      type: Boolean,
      default: false
    },
    drawerList: {
      type: [Array, Object],
      default: () => []
    }
  },
  data() {
    return {
      MESSAGE_TYPE,
      MESSAGE_STATE_TYPE,
      show: false,
      initSrcIndex: -1,
      previewSrcList: [],
      drawerListMap: [],
      mappingUrl: {}, // 图片路径
      showRichImg: false,
      previewRichSrcList: [],
      seatImg: null
    };
  },
  created () {
    this.getUrl();
  },
  watch: {
    drawerList: {
      handler() {
        this.drawerListMap = this.drawerList.map(res => {
          const { msg, msgType } = res
          if (msgType === 'ROBOT' && msg && msg?.contents?.length) {
            msg?.contents?.map(async(item) => {
              if (item.html) {
                let content = item.content
                const { srcArr } = getImgSrcObj(content)
                const nArr = srcArr.filter((src) => !Object.keys(this.mappingUrl).includes(src))
                if (nArr && nArr.length) {
                  const { data } = ImApi.getImgUrl(nArr.join(','))
                  Object.assign(this.mappingUrl, data || {})
                }
                if (srcArr && srcArr.length) {
                  Object.keys(this.mappingUrl).map((key) => {
                    content = content.replace(key, this.mappingUrl[key])
                  })
                }
                item.content = content
              }
            })
          }
          // 文本消息展示表情,(你好#E-s05测试)签标签替换
          if (msgType === MESSAGE_TYPE.TEXT && msg) {
            res.msg = replaceEmoji(msg)
          }
          return res
        })
      },
      deep: true
    }
  },
  methods: {
    DOMPurify(str) {
      return DOMPurify.sanitize(str)
    },
    // 关闭弹窗
    drawerCloseHandler() {
      this.$emit('update:drawerShow', false);
    },
    // 获取角色类型
    getAuthor(item) {
      const authorMap = {
        [MESSAGE_AUTHOR_TYPE.AGENT]: this.$lang('坐席'),
        [MESSAGE_AUTHOR_TYPE.VISITOR]: this.$lang('访客')
      };
      const srcMap = {
        [MESSAGE_SOURCE_TYPE.SYSTEM]: this.$lang('系统'),
        [MESSAGE_SOURCE_TYPE.ROBOT]: this.$lang('机器人')
      };
      if (item.srcType === MESSAGE_SOURCE_TYPE.COMMON) {
        return authorMap[item.author] || '--';
      }
      return srcMap[item.srcType] || '--';
    },
    // 获取角色类型
    getAuthorType(item) {
      const authorMap = {
        [MESSAGE_AUTHOR_TYPE.AGENT]: 'AGENT',
        [MESSAGE_AUTHOR_TYPE.VISITOR]: 'CUSTOMER'
      }
      const srcMap = {
        [MESSAGE_SOURCE_TYPE.SYSTEM]: 'SYSTEM',
        [MESSAGE_SOURCE_TYPE.ROBOT]: 'ROBOT'
      }
      if (item.srcType === MESSAGE_SOURCE_TYPE.COMMON) {
        return authorMap[item.author] || '--'
      }
      // 第三方推送过来的消息统称为系统消息,所以要做第二层判断
      if (item.srcType === MESSAGE_SOURCE_TYPE.ROBOT && item.author === MESSAGE_AUTHOR_TYPE.VISITOR) {
        return authorMap[item.author] || '--'
      }
      return srcMap[item.srcType] || '--'
    },
    // 获取头像地址
    getAvaterUrl(item) {
      const { skillGroupAvatarUrl = '' } = item
      const _type = this.getAuthorType(item)
      let url = ''
      if (_type === 'CUSTOMER') {
        // url = visitor
        url = skillGroupAvatarUrl || visitor
      } else {
        url = this.seatImg || seats
        // if (item.agentName === '系统消息') {
        //   url = systemAvatar
        // } else {
        //   url = seats
        // }
      }
      return url
    },
    /**
     * 获取名称
     */
    getName(item) {
      if (item.author === MESSAGE_AUTHOR_TYPE.AGENT) {
        return item.agentName;
      }
      if (item.author === MESSAGE_AUTHOR_TYPE.VISITOR) {
        return item.customerName;
      }
      return '';
    },
    // 展示图片
    showImage(url) {
      this.show = true;
      this.initSrcIndex = 0;
      this.previewSrcList = [url];
    },
    // 富文本图片预览
    clickHtml($event) {
      const imgElement = $event?.target
      const imgSrc = imgElement?.src
      if (imgSrc) {
        this.showImage(imgSrc)
      }
    },
    getComponent(item) {
      if (item.button) {
        return 'ButtonComp'
      } else if (item.card) {
        return 'CardList'
      } else if (item.option) {
        return 'OptionComp'
      } else if (item.ul) {
        return 'GuessComp'
      }
      return false
    },
    // 获取坐席端头像
    async getUrl() {
      const { data } = await ImApi.getSkillAll()
      const findItem = data?.find((res) => res?.skillGroupCode === 'robot')
      if (findItem && findItem?.skillGroupAvatarUrl) {
        return (this.seatImg = findItem?.skillGroupAvatarUrl)
      }
      return (this.seatImg = seats)
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.el-drawer__header) {
  font-size: 16px;
  margin-bottom: 0px;
}
::v-deep .avue-drawer__body {
  height: calc(100vh - 75px);
}
.noData {
  margin: 10px 0px;
  text-align: center;
  font-size: 14px;
}
.drawer-container {
  width: 100%;
  height: 100%;
  overflow: hidden auto;
  // border-top: 1px solid $list-tip-color;
  padding-right: 5px;
  .drawer-article {
    display: flex;
    margin: 15px 0;
    .drawer-avater {
      display: block;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin: 10px 10px 0 0;
    }
    .drawer-msg {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    .drawer-title {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #999;
      margin-bottom: 5px;
      span {
        display: inline-block;
      }
      .avatar-name {
        border-radius: 2px;
        background-color: #f0f6fe;
        color: #87b9f6;
        padding: 2px 6px;
        margin-right: 4px;
      }
      .avatar-name {
        background-color: #fff1e6;
        color: #fd9040;
      }
    }
    .drawer-time {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .drawer-text {
      margin-top: 10px;
      display: flex;
      .text {
        max-width: 90%;
        padding: 10px;
        border-radius: 8px;
        background-color: #f4f4f4;
        line-height: 25px;
        text-align: left;
        word-wrap: break-word;
      }
    }
    .drawer-image {
      // background-color: #e3e3e3;
      ::v-deep img {
        max-width: 200px;
        max-height: 200px;
        object-fit: contain;
      }
    }
  }
.seats {
  flex-direction: row-reverse;
  .drawer-title {
    flex-direction: row-reverse;
  }
  .drawer-msg {
    text-align: right;
    margin-right: 10px;
  }
  .drawer-text {
    flex-direction: row-reverse;
  }
}
.file-card {
  background-color: #f4f4f4;
  padding: 10px;
}
.withdraw{
  margin: 5px;
  color: #E60012;
}
::v-deep .em-icon{
  width: 18px;
  height: 18px;
  vertical-align: text-bottom;
}
</style>
